export function roundToNDecimalPlaces(num: number, n: number, strategy: 'round' | 'floor' | 'ceil' = 'round'): number {
  const factor = Math.pow(10, n);
  switch (strategy) {
    case 'round':
      return Math.round(num * factor) / factor;
    case 'floor':
      return Math.floor(num * factor) / factor;
    case 'ceil':
      return Math.ceil(num * factor) / factor;
  }
}
